import { createProviderToken } from '@core/common-legacy';
import type { IconName } from '@core/user-interface-legacy';

export type ReportsEmptyStateConfig = {
  icon: IconName;
  title: string;
  desc: string;
};

export type ReportsEmptyStateHandler = (reason: string) => ReportsEmptyStateConfig | null;

export type ReportsEmptyStateHandlerFactory = () => ReportsEmptyStateHandler;

export const {
  inject: injectReportsEmptyStateHandlerFactory,
  provide: provideReportsEmptyStateHandlerFactory,
} = createProviderToken<ReportsEmptyStateHandlerFactory>('ReportsEmptyStateHandlerFactory')();
